import { populate } from 'populate'; import dragonBones from 'pixi-dragonbones';
import { SeasonPassRewardPremium } from 'Layouts/Quests/SeasonPass/SeasonPassRewardPremium';
import { SeasonPassRewardFree } from 'Layouts/Quests/SeasonPass/SeasonPassRewardFree';

const raw = {
  className: '',
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: '1b7e3942-062c-4dee-b7cb-ace5783bb913',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '402393d5-de29-426b-8390-0f7bc1d11837',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '1b7e3942-062c-4dee-b7cb-ace5783bb913',
      data: ''
    },
    {
      id: 'c8fc9122-2189-45ca-be29-db75cc40bebf',
      type: 'Layout',
      name: 'PremiumReward',
      nameSpace: '',
      className: '',
      path: 'src/Layouts/Quests/SeasonPass/SeasonPassRewardPremium.ts',
      percentX: 0,
      percentY: 0,
      x: 0,
      y: 5,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: '402393d5-de29-426b-8390-0f7bc1d11837',
      data: ''
    },
    {
      id: 'c121f816-c0ad-4fef-8877-a20b95d3307b',
      type: 'Layout',
      name: 'FreeReward',
      nameSpace: '',
      className: '',
      path: 'src/Layouts/Quests/SeasonPass/SeasonPassRewardFree.ts',
      percentX: 0,
      percentY: 0,
      x: 0,
      y: 210,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: '402393d5-de29-426b-8390-0f7bc1d11837',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class SeasonPassRank {
  static raw = raw;
  root: PIXI.Container
  PremiumReward: SeasonPassRewardPremium
  FreeReward: SeasonPassRewardFree

  constructor() {
    populate(this, raw);
  }
}
